import { useTranslation } from '@multaqa/i18n'

/** The "(optional)" tag after the label of a field a supplier can go without. */
export function OptionalTag() {
  const { t } = useTranslation()

  return <span className="font-normal text-muted-foreground"> ({t('supplier.optional')})</span>
}
